<template>
  <span>
    <router-link :to="'/orders/' + id" v-if="userHasReadPermission(PermissionTypes.OrderPermissionTypes.order) && !disabled" :target="target" :class="{'router-link-newtab': newTab}">
      {{name}}
    </router-link>
    <span v-else>
      {{name}}
    </span>
  </span>
</template>

<script>
export default {
  name: 'LinkOrder',
  props: {
    id: Number,
    name: String,
    newTab: {
      type: Boolean,
      default: true
    },
    disabled: Boolean
  },
  computed: {
    target() {
      if(this.newTab)
        return '_blank'

      return '_self'
    }
  }
}
</script>
